/*eslint-disable */
import React, { Component } from "react";
import Loader from "react-loader-spinner";
import ReactTooltip from "react-tooltip";
import CommentForm from "./CommentForm";
import { GrDown, GrUp } from "react-icons/gr";
import ButtonLoader from "../../assets/svg/loading.svg";
import moment from "moment";
import FormSearchInput from "../inputs/FormSearchInput";
import TextInput from "../inputs/TextInput";
import SelectInput from "../inputs/SelectInput";
import Select from "react-select";
import {
  Post,
  Get,
  Delete,
  Put,
  GetwithQueryString,
} from "../../utility/fetch";
import { URLAPI } from "../../utility/ApiMethods";
import { GrEdit } from "react-icons/gr";
import data from "../../data";
import { ImCheckmark, ImCancelCircle, ImEye } from "react-icons/im";
import Cookies from "js-cookie";
import {
  deleteMessage,
  errorMessage,
  successMessage,
} from "../../resources/alert";
import ViewRequestDetails from "../layouts/ViewRequestDetails";
import LoadingSpinner from "../../resources/loadingSpinner";

// import PureModal from 'react-pure-modal';
import { Multiselect } from "multiselect-react-dropdown";
import { GiTrashCan } from "react-icons/gi";
import notification from "../../utility/notification";
import { formatDateforPicker } from "../../utility/dateTime";
import AssignAssetFormModal from "../layouts/AssignAssetFormModal";
import ColorController from "../../controllers/ColorController";
import ViewWithdrawalDetails from "../layouts/ViewWithdrawalDetails";

const bottomBorder = {
  borderBottom: ".5px solid rgba(99,99,99,.6)",
};
const tableBorder = {
  border: "none",
  borderRight: "1px solid #0000000A",
  borderBottom: "1px solid #0000000A",
};

class AssetAssignRequest extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      selectedDate: "All Cases",
      startDate: "",
      endDate: "",
      searchText: null,
      calendarDate: new Date(),
      visible: false,
      requestButton: "Requests",
      approvedButton: "Approved",
      initiatedreq: [],
      withdrawalList: [],
      requestId: 0,
      category: "",
      beneficiary: "",
      details: "",
      date: "",
      cost: "",
      title: "",
      request: false,
      withdrawal: false,
      assignedAssetItemId: [],
      availableItems: [],
    };
    this.filterReviewsOnApprover = this.filterReviewsOnApprover.bind(this);
  }

  openModal = (item) => {
    this.setState({
      visible: true,
      // requestId: item.id,
      // beneficiary: item.beneficiary,
      // cost: item.cost,
      // category: item.category,
      // title: item.title,
      // details: item.details,
      // date: item.date,
    });
  };

  closeModal = () => {
    this.setState({ visible: false });
  };

  handleDate = async (e) => {
    const { value } = e.target;

    this.setState({
      selectedDate: value,
      calendarDate: value,
    });
    // searchText('');

    switch (value) {
      case "Today":
        // get meetings for today
        this.setState({
          startDate: formatDateforPicker(new Date()),
          endDate: formatDateforPicker(new Date()),
        });

        break;
      case "This Week":
        // get meetings for this week
        this.setState({
          startDate: formatDateforPicker(moment().startOf("week").toDate()),
          endDate: formatDateforPicker(moment().endOf("week").toDate()),
        });

        break;
      case "This Month":
        // get meetings for this month
        this.setState({
          startDate: formatDateforPicker(moment().startOf("month").toDate()),
          endDate: formatDateforPicker(moment().endOf("month").toDate()),
        });
        break;
      case "Calendar":
        // get meetings for the day selected in the calendar
        this.setState({
          startDate: formatDateforPicker(this.state.calendarDate),
          endDate: formatDateforPicker(this.state.calendarDate),
        });
        break;
      case "All Cases":
        // get meetings for the day selected in the calendar
        this.setState({
          startDate: "",
          endDate: "",
        });
        break;
      default:
        break;
    }
  };

  setApproved = () => {
    this.setState({
      requestButton: "Approved",
    });
  };

  getApproval = (data) => {
    if (this._isMounted) {
      let _records = Array.isArray(data) ? data : [];
      console.log(_records, "_records");
      this.setState({ initiatedreq: _records, loading: false });
      this.props.recordRequestLength({
        loadingRequest: false,
        length: this.state.initiatedreq.length,
      });
    }
  };

  getWithdrawal = (data) => {
    if (this._isMounted) {
      let _records = Array.isArray(data) ? data : [];
      this.setState({ withdrawalList: _records, loading: false });
      //   this.props.recordRequestLength({ loadingWithdrawal: false });
    }
  };

  filterReviewsOnApprover = () => {
    this.setState({
      initiatedreq: this.state.initiatedreq.filter(
        (rec) => rec.id !== parseInt(this.state.requestId)
      ),
    });
    Get(URLAPI.requestApprovals.Get, this.getApproval);
  };

  componentDidMount() {
    this._isMounted = true;
    this.setState({ loading: true });
    try {
      Get("api/assetassign/pendingassignlist", this.getApproval);
      //   Get('api/assigneditems/withdrawallist', this.getWithdrawal);
    } catch (err) {
      console.log(err);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  searchSpace = (event) => {
    let keyword = event.target.value;
    this.setState({ search: keyword });
  };
  returnRequestButtonState = () => {
    this.setState({
      requestButton: "Requests",
    });
  };

  handleGetAvailableItems = (itemCategoryId) => {
    Get(`api/check/availableitems/${itemCategoryId}`, this.getItems);
  };

  getItems = (data) => {
    if (this._isMounted) {
      let _records = Array.isArray(data) ? data : [];
      const multiSelectData = [];

      _records.forEach((element) => {
        multiSelectData.push({ name: element.itemName, id: element.id });
      });

      this.setState({ availableItems: multiSelectData, loadRequest: false });
    }
  };

  onWithdraw = () => {
    this.setState({ loadComment: true });
    const { comment } = this.state;

    Put(
      { comment },
      `api/assigneditems/withdraw?id=${this.state.itemWithdrawalId}`,
      this.handleWithdrawalResult
    );
  };

  handleWithdrawalResult = (res) => {
    if (res.code === 1) {
      this.setState({
        visibleWithdrawalComment: false,
        loadComment: false,
        loading: true,
        comment: "",
      });
      successMessage(res.message);
      Get("api/assetassign/pendingassignlist", this.getApproval);
      //   Get('api/assigneditems/withdrawallist', this.getWithdrawal);
    } else {
      errorMessage(res.message);
      this.setState({ loadComment: false, visibleWithdrawalComment: false });
    }
  };

  onAssign = () => {
    this.setState({ loadComment: true });
    const { action, comment } = this.state;

    // console.log({
    //   itemRequestId: this.state.itemRequestId,
    //   assignedAssetItemId: this.state.assignedAssetItemId,
    //   action,
    //   comment,
    // }, 'onAssign >>>>');
    Put(
      {
        itemRequestId: this.state.itemRequestId,
        assignedAssetItemId: this.state.assignedAssetItemId,
        action,
        comment,
      },
      "api/assetassign/assign",
      this.handleAssignResult
    );
  };

  handleAssignResult = async (res) => {
    if (res.code === 1) {
      this.setState({
        visibleComment: false,
        loadComment: false,
        loading: true,
        comment: "",
      });
      successMessage(res.message);
      Get("api/assetassign/pendingassignlist", this.getApproval);
      //   Get('api/assigneditems/withdrawallist', this.getWithdrawal);
    } else {
      errorMessage(res.message);
      this.setState({ loadComment: false, visibleComment: false, comment: "" });
    }
  };
  handleAccordion = async (value) => {
    const { withdrawal, request } = this.state;
    if (value === "Asset Request") {
      this.setState({ request: !request });
    }

    if (value === "Asset Withdrawal") {
      this.setState({ withdrawal: !withdrawal });
    }
  };

  renderMessage = (value) => {
    if (this.state.requestButton === "Requests")
      return (
        <>
          <a
            href="#"
            style={{ backgroundColor: "white" }}
            onClick={() => this.handleAccordion(value)}
            className="w-100 flex"
            style={{ textDecoration: "none", color: "black" }}
          >
            <p style={{ fontSize: 15 }}>{value}</p>
          </a>
        </>
      );
  };

  pendingRequestRecordLength = (val) => {
    this.setState({
      pendingRequestLength: val.len,
      loadingRequest: val.loading,
    });
  };

  render() {
    const {
      sequence,
      button,
      loading,
      loadTable,
      loadForm,
      approval,
      visibleDetails,
      visible,
    } = this.state;
    return (
      <>
        <div className="row">
          <div className="col-12">
            <div
              id="bordered-table"
              className="table-view "
              style={{
                borderCollapse: "collapse",
                borderSpacing: "25px 15px",
                marginLeft: 10,
                // marginRight: 10,
                // border: 'none',
                ...this.props.overrideTableStyles,
              }}
            >
              <div
                className="table-header"
                style={{
                  backgroundColor: `${this.props.headerBGColor || "#F0F0F0"}`,
                  color: `${this.props.headerColor || "#43425D"}`,
                }}
              >
                <div className="table-row">
                  <div
                    className="th case title w-25"
                    style={{ ...tableBorder }}
                  >
                    <p>Request Officer</p>
                  </div>
                  <div
                    className="th case title w-25"
                    style={{ ...tableBorder }}
                  >
                    <p>Requests Title</p>
                  </div>
                  <div
                    className="th case title w-25"
                    style={{ ...tableBorder }}
                  >
                    <p>Assignee</p>
                  </div>
                  <div
                    className="th case title w-25"
                    style={{ ...tableBorder }}
                  >
                    <p>Item Count</p>
                  </div>
                  <div
                    className="th case title w-25"
                    style={{ ...tableBorder }}
                  >
                    <p>Date Submitted</p>
                  </div>
                  <div
                    className="th case title w-25"
                    style={{ ...tableBorder }}
                  >
                    <p>Actions</p>
                  </div>
                </div>
              </div>

              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignContents: "center",
                  }}
                >
                  <Loader
                    type="ThreeDots"
                    color="green"
                    height={80}
                    width={80}
                  />
                </div>
              ) : (
                <>
                  {this.state.initiatedreq.length === 0 ? (
                    <div style={{ marginLeft: 10 }}>
                      <br />
                      <h3>No Pending Asset Request</h3>
                    </div>
                  ) : (
                    <div className="table-body no-border">
                      {this.state.initiatedreq.map((value, i) => {
                        return (
                          <>
                            <div className="table-row no-border">
                              <div
                                key={i}
                                className="td font-sz-13"
                                style={{
                                  ...tableBorder,
                                }}
                              >
                                {value.requestedBy}
                              </div>
                              <div
                                className="td font-sz-13"
                                style={{ ...tableBorder }}
                              >
                                {value.requestTitle}
                              </div>
                              <div
                                className="td font-sz-13"
                                style={{ ...tableBorder }}
                              >
                                {value.beneficiary}
                              </div>
                              <div
                                className="td font-sz-13"
                                style={{ ...tableBorder }}
                              >
                                {value.itemCount}
                              </div>
                              <div
                                className="td font-sz-13"
                                style={{ ...tableBorder }}
                              >
                                {value.dateSubmitted}
                              </div>
                              <div
                                className="td m-l-10 font-sz-22 pointer"
                                style={{ ...tableBorder }}
                              >
                                <button
                                  style={{
                                    backgroundColor:
                                      this.state.visibility ===
                                      `${value.id}-open`
                                        ? "#44435D"
                                        : "white",
                                    // color: this.state.visibility === `${value.id}-open` ? 'white' : 'black'
                                  }}
                                  data-tip
                                  data-for={`${value.id}-drop-btn`}
                                  type="button"
                                  className="pointer td actions"
                                  onClick={() => {
                                    this.setState({
                                      visibility:
                                        this.state.visibility ===
                                        `${value.id}-open`
                                          ? `${value.id}-close`
                                          : `${value.id}-open`,
                                      // itemRequestId: value.id,
                                    });
                                  }}
                                >
                                  {this.state.visibility ===
                                  `${value.id}-open` ? (
                                    <GrUp />
                                  ) : (
                                    <GrDown />
                                  )}
                                </button>
                                <ReactTooltip
                                  id={`${value.id}-drop-btn`}
                                  type={
                                    this.state.visibility === `${value.id}-open`
                                      ? "error"
                                      : "dark"
                                  }
                                  effect="solid"
                                >
                                  {this.state.visibility ===
                                  `${value.id}-open` ? (
                                    <span>Close Requested Items</span>
                                  ) : (
                                    <span>Open Requested Items</span>
                                  )}
                                </ReactTooltip>
                                {"                        "}
                                <button
                                  data-tip
                                  data-for="view-details"
                                  type="button"
                                  className="pointer td actions"
                                  onClick={() =>
                                    this.setState({
                                      visibleRequestDetails: true,
                                      requestedBy: value.requestedBy,
                                      requestTitle: value.requestTitle,
                                      beneficiary: value.beneficiary,
                                      requestDetail: value.requestDetail,
                                      itemCount: value.itemCount,
                                      dateSubmitted: value.dateSubmitted,
                                      lastUpdated: value.lastUpdated,
                                      supportingDoc: value.supportingDoc,
                                      approvers: value.approvers,
                                      assetItems: value.assetItems,
                                    })
                                  }
                                >
                                  <ImEye />
                                </button>
                                <ReactTooltip
                                  id="view-details"
                                  type="success"
                                  effect="solid"
                                >
                                  <span>View Details</span>
                                </ReactTooltip>
                              </div>
                            </div>

                            {this.state.visibility === `${value.id}-open` ? (
                              <>
                                <div
                                  className="table-row no-border"
                                  style={{
                                    backgroundColor: "#44435D",
                                    color: "white",
                                  }}
                                >
                                  <div
                                    key={i}
                                    className="td font-sz-13"
                                    style={{
                                      ...tableBorder,
                                    }}
                                  >
                                    Item name
                                  </div>
                                  <div
                                    className="td font-sz-13"
                                    style={{ ...tableBorder }}
                                  >
                                    Quantity
                                  </div>
                                  <div
                                    className="td font-sz-13"
                                    style={{ ...tableBorder }}
                                  >
                                    Category
                                  </div>
                                  <div
                                    className="td font-sz-13"
                                    style={{ ...tableBorder }}
                                  >
                                    Status
                                  </div>
                                  <div
                                    className="td font-sz-13"
                                    style={{ ...tableBorder }}
                                  >
                                    Action
                                  </div>
                                </div>

                                {value.assetItems.length === 0 ? (
                                  <div style={{ textAlign: "center" }}>
                                    <br />
                                    <h2>No Asset Items</h2>
                                    <br />
                                  </div>
                                ) : null}
                                {value.assetItems.map((value, i) => (
                                  <div
                                    key={i}
                                    className="table-row no-border"
                                    style={{
                                      backgroundColor: "#F0F0F0",
                                      color: "black",
                                    }}
                                  >
                                    <div
                                      className="td font-sz-13"
                                      style={{
                                        ...tableBorder,
                                      }}
                                    >
                                      {value.itemName}
                                    </div>
                                    <div
                                      className="td font-sz-13"
                                      style={{ ...tableBorder }}
                                    >
                                      {value.quantity}
                                    </div>
                                    <div
                                      className="td font-sz-13"
                                      style={{ ...tableBorder }}
                                    >
                                      {value.categoryName}
                                    </div>
                                    <div
                                      className="td font-sz-13"
                                      style={{ ...tableBorder }}
                                    >
                                      {value.requestedItemStatus}
                                    </div>
                                    <div
                                      className="td font-sz-13"
                                      style={{ ...tableBorder }}
                                    >
                                      {value.requestedItemStatus ===
                                      "UnAssigned" ? (
                                        <button
                                          className="btn"
                                          onClick={() => {
                                            this.setState({
                                              visible: !this.state.visible,
                                              loadRequest: true,
                                              itemQuantity: value.quantity,
                                              itemRequestId: value.id,
                                            });
                                            this.handleGetAvailableItems(
                                              value.itemCategoryId
                                            );
                                          }}
                                        >
                                          Assign
                                        </button>
                                      ) : null}
                                    </div>
                                  </div>
                                ))}
                              </>
                            ) : null}
                          </>
                        );
                      })}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        {this.state.visibleComment && (
          <AssignAssetFormModal
            loadComment={this.state.loadComment}
            handleAssign={() => this.onAssign()}
            comment={this.state.comment}
            handleComment={(value) => this.setState({ comment: value })}
            closeModal={() =>
              this.setState({ visibleComment: false, comment: "" })
            }
          />
        )}

        {this.state.visibleWithdrawalComment && (
          <AssignAssetFormModal
            loadComment={this.state.loadComment}
            handleAssign={() => this.onWithdraw()}
            comment={this.state.comment}
            handleComment={(value) => this.setState({ comment: value })}
            closeModal={() =>
              this.setState({ visibleWithdrawalComment: false })
            }
          />
        )}

        {this.state.visibleRequestDetails && (
          <ViewRequestDetails
            requestedBy={this.state.requestedBy}
            requestTitle={this.state.requestTitle}
            beneficiary={this.state.beneficiary}
            requestDetail={this.state.requestDetail}
            itemCount={this.state.itemCount}
            dateSubmitted={this.state.dateSubmitted}
            lastUpdated={this.state.lastUpdated}
            supportingDoc={this.state.supportingDoc}
            approvers={this.state.approvers}
            assetItems={this.state.assetItems}
            closeModal={() => this.setState({ visibleRequestDetails: false })}
          />
        )}

        {/* view withdrawal details */}
        {this.state.visibleWithdrawalDetails && (
          <ViewWithdrawalDetails
            requestedItemTitle={this.state.requestedItemTitle}
            requestedItemDetail={this.state.requestedItemDetail}
            itemName={this.state.itemName}
            beneficiary={this.state.beneficiary}
            dateAssigned={this.state.dateAssigned}
            assignedTo={this.state.assignedTo}
            assignedStatus={this.state.assignedStatus}
            assignedBy={this.state.assignedBy}
            assignComment={this.state.assignComment}
            serialNumber={this.state.serialNumber}
            requestDate={this.state.requestDate}
            supportingDoc={this.state.supportingDoc}
            closeModal={() =>
              this.setState({ visibleWithdrawalDetails: false })
            }
          />
        )}

        {/* Assign approvers */}
      </>
    );
  }
}

export default AssetAssignRequest;
